import React from "react";
import { AddLoanContainer } from "../../../containers";

const AddLoan = (props) => {
  return <AddLoanContainer {...props} />;
};

export default AddLoan;
